export default __webpack_public_path__ + "static/media/mobile_native_dev_img1.155e78bf.svg";